import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private totalRequests = 0;

  // List of URL substrings to exclude from loader
  private excludedUrls: string[] = [
    '/api/save_draft',
    '/api/save_eeoc_veeva',
    '/api/save_ira_eeoc_veeva',
    'api/save_edit_la',
    '/api/save_from_support_substantiation',
    '/api/get_save_notifications',
    '/api/update_notificationstatus',
    '/api/delete_objects',
    '/api/check_duplicates',
    '/api/fetch_savedraft'
  ];

  constructor(private loadingService: LoadingService) {}

  
private isExcluded(request: HttpRequest<any>): boolean {
  const showLoaderHeader = request.headers.get('X-Show-Loader');
  const isExcludedUrl = this.excludedUrls.some((url) => request.url.includes(url));

  // If header explicitly says to show loader, override exclusion
  if (showLoaderHeader === 'true') {
    return false;
  }

  return isExcludedUrl;
}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const shouldSkip = this.isExcluded(request);

    if (!shouldSkip) {
      this.totalRequests++;
      this.loadingService.setLoading(true);
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (!shouldSkip) {
          this.totalRequests--;
          if (this.totalRequests === 0) {
            this.loadingService.setLoading(false);
          }
        }
      })
    );
  }
}
